import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/#work', text: 'What we build' },
  { to: '/#process', text: 'How we work' },
  { to: '/#about', text: 'About' },
  { to: '/pricing', text: 'Rate card' },
];

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="nav">
      <div className="nav-inner">
        <Link to="/" className="brand" onClick={() => setOpen(false)}>
          <img src="/images/hmtlogogreen.png" alt="" className="brand-logo" />
          <span className="brand-mark">HMTechz</span>
          <span className="brand-sub">Hakuna Matata Technologies</span>
        </Link>
        <nav className="nav-links" aria-label="Primary">
          {navLinks.map((item) => (
            <Link
              key={item.text}
              to={item.to}
              className={item.to === '/pricing' && pathname === '/pricing' ? 'active' : undefined}
            >
              {item.text}
            </Link>
          ))}
          <Link to="/#contact" className="btn green nav-cta">Start a project</Link>
        </nav>
        <button
          className="nav-burger"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          Menu
        </button>
      </div>
      <nav className={`nav-mobile${open ? ' open' : ''}`} aria-label="Mobile">
        {navLinks.map((item) => (
          <Link key={item.text} to={item.to} onClick={() => setOpen(false)}>
            {item.text}
          </Link>
        ))}
        <Link to="/#contact" onClick={() => setOpen(false)}>Start a project →</Link>
      </nav>
    </header>
  );
};
